import React, { Fragment } from "react";
import styled, { css } from "styled-components";
import { ICON_RED_MINUS_SRC, ListIcon } from "../../../resources/Assets";
import { CardIconImg } from "../../../resources/CardIcon";

/*
  props
  state, disable, R_Icon,
  L_Icon, text
*/
const ListPayment = (props) => {
  // const viewData = ListTextData;
  const viewData = props.data;
  const viewHBody = viewData.Header.H_Title.H_Body;

  return (
    <Container active={viewData.Active} disable={viewData.Disable}>
      {/* HEAD START */}
      <Header>
        <H_Title onClick={viewData.Header.H_Title.action}>
          {/* left */}
          {viewData.Header.H_Title.L_Icon && (
            <L_Icon>
              <L_Icon_Img Bg={viewData.Header.H_Title.L_Icon.img} />
            </L_Icon>
          )}
          {/* center */}
          <H_Body>
            <H_Body_Title>{viewHBody.H_Body_Title}</H_Body_Title>

            <H_Body_Subs>
              {viewHBody.H_Body_Subs.map((data, i) => (
                <H_Body_Subs_Text key={"H_Body_Subs" + i} status={data.status}>
                  {data.text}
                </H_Body_Subs_Text>
              ))}
            </H_Body_Subs>
          </H_Body>
        </H_Title>
        {/* right */}
        {viewData.Header.R_Icon && viewData.Header.R_Icon.img != "" && (
          <R_Icon Bg={viewData.Header.R_Icon.img} onClick={viewData.Header.R_Icon.action} />
        )}
      </Header>
      {/* HEAD END */}

      {/* BODY START */}
      {viewData.Body && viewData.Body != "" && <Body>{viewData.Body}</Body>}
      {/* BODY END */}

      {/* BOTTOM START */}
      {/* BOTTOM END */}
    </Container>
  );
};

const ListTextData = {
  Header: {
    H_Title: {
      action: () => testAction(),
      L_Icon: {
        img: CardIconImg({
          cardInfo: {
            cardCd: "027",
          },
        }),
      },

      H_Body: {
        H_Body_Title: "신한은행",
        H_Body_Subs: [
          {
            status: "default",
            text: "487*",
          },
          {
            status: "error",
            text: "결제실패",
          },
        ],
      },
    },

    R_Icon: {
      img: ICON_RED_MINUS_SRC,
      action: () => testAction(),
    },
  },

  Body: "TEXT",
};

const testAction = () => {
  alert("TEST");
};

const Container = styled.div`
  display: flex;
  /* width: 320px; */
  width: calc(100% - 40px);
  padding: 20px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;

  border-radius: 10px;

  background: ${(props) => (props.disable ? "#EDEDF0" : "#F7F7FA")};

  ${(props) =>
    props.active &&
    css`
      border: 1px solid #6b65de;
    `}
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;

const H_Title = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
`;

const H_Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--borderRadius, 4px);
  flex: 1 0 0;
`;

const H_Body_Title = styled.div`
  align-self: stretch;
  color: #333;

  /* Title/3/SemiBold */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px; /* 157.143% */
  letter-spacing: -0.28px;
`;

const H_Body_Subs = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

const H_Body_Subs_Text = styled.div`
  color: ${
    (props) => (props.status === "default" ? "#888" : "var(--red-400, #FF6259)")
    // : props.status === "error" ? "var(--red-400, #FF6259)"
  };

  /* Body/3/Regular */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  letter-spacing: -0.24px;
`;

const L_Icon = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  padding: 8px 7px 7.113px 8px;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  background: #fff;
`;

const L_Icon_Img = styled.div`
  width: 25px;
  height: 24.887px;
  flex-shrink: 0;
  background: url(${(props) => props.Bg});
  background-repeat: no-repeat;
  background-position: center center;
`;

const R_Icon = styled.div`
  width: 40px;
  height: 40px;
  background: url(${(props) => props.Bg});
`;

const Body = styled.div`
  display: flex;
  width: 288px;
  padding: 8px 16px;
  align-items: flex-start;
  gap: 10px;
  border-radius: 6px;
  background: #fff;

  color: #888;

  /* Body/3/Regular */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  letter-spacing: -0.24px;

  flex: 1 0 0;
`;

export default ListPayment;
